module.exports = __webpack_public_path__ + "src/assets/textures/env/windmill/mill_wheel_1k_bake.png";